
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {WorkTimeComponent} from "./workTime.component";
import {TranslateModule} from "@ngx-translate/core";
import {WorkTimeDetailsDialogComponent} from "./dialog/workTimeDetails.component";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatDialogModule} from "@angular/material/dialog";
import {FuseDirectivesModule} from "../../../@fuse/directives/directives";

@NgModule({
    declarations: [
        WorkTimeComponent,
        WorkTimeDetailsDialogComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        FlexLayoutModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        TranslateModule,
        MatToolbarModule,
        MatDialogModule,
        FuseDirectivesModule,
    ],
    providers: [],
    exports: [
        WorkTimeComponent,
    ],
    bootstrap: [
    ]
})
export class WorkTimeModule { }
